export function getCardinalEnumKeys(enumObj: any): string[] {
  return Object.keys(enumObj).filter(key => !isNaN(Number(enumObj[key])));
}